module.exports = __webpack_public_path__ + "img/silverado-19.ef392822.jpg";